var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 90,
    viewBox: "0 0 62 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0002 31.1125H17.1127M31.0002 31.1125V3.33337H17.1127C13.429 3.33337 9.89611 4.79674 7.29131 7.40154C4.68651 10.0063 3.22314 13.5392 3.22314 17.223C3.22314 20.9067 4.68651 24.4396 7.29131 27.0444C9.89611 29.6492 13.429 31.1125 17.1127 31.1125M31.0002 31.1125V58.8875H17.1127M31.0002 31.1125H44.8877M17.1127 31.1125C13.4295 31.1125 9.89719 32.5757 7.29278 35.1801C4.68837 37.7845 3.22523 41.3168 3.22523 45C3.22523 48.6832 4.68837 52.2156 7.29278 54.82C9.89719 57.4244 13.4295 58.8875 17.1127 58.8875M17.1127 58.8875C14.3662 58.8875 11.6814 59.7019 9.39768 61.2277C7.11398 62.7535 5.33398 64.9222 4.28275 67.4596C3.23152 69.9969 2.95625 72.789 3.49177 75.4828C4.02728 78.1766 5.34953 80.6511 7.29131 82.5935C9.2331 84.5359 11.7072 85.8589 14.4009 86.3952C17.0945 86.9315 19.8867 86.6571 22.4244 85.6066C24.962 84.5561 27.1313 82.7768 28.6577 80.4935C30.1842 78.2103 30.9994 75.5257 31.0002 72.7792M44.8877 31.1125C41.2045 31.1125 37.6722 32.5757 35.0678 35.1801C32.4634 37.7845 31.0002 41.3168 31.0002 45C31.0002 48.6832 32.4634 52.2156 35.0678 54.82C37.6722 57.4244 41.2045 58.8875 44.8877 58.8875C48.5709 58.8875 52.1033 57.4244 54.7077 54.82C57.3121 52.2156 58.7752 48.6832 58.7752 45C58.7752 41.3168 57.3121 37.7845 54.7077 35.1801C52.1033 32.5757 48.5709 31.1125 44.8877 31.1125ZM44.8877 31.1125C48.5715 31.1125 52.1043 29.6492 54.7091 27.0444C57.3139 24.4396 58.7773 20.9067 58.7773 17.223C58.7773 13.5392 57.3139 10.0063 54.7091 7.40154C52.1043 4.79674 48.5715 3.33337 44.8877 3.33337",
    stroke: "white",
    strokeWidth: 6.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.e17461cc502db6a9625d5e5e5f57ec5d.svg";
export { ForwardRef as ReactComponent };